'use strict';
const ConstantSettings = {
    maxZoom: 18,
    maxZoomOnClick: 8,
    minZoom: 5,
    minDistance: { 18: 0.206021, 17: 0.493205, 16: 0.826411, 15: 1.402823, 14: 2.720561, 13: 3.564114, 12: 4.406856, 11: 6.294761, 10: 9.224118, 9: 14.372921, 8: 19.793621 },
    defaultListChunk: 25,
    directivePriority: 300,
    fasterDelayTimeout: 100,
    maximumMapDataAge: 3000,
    mapUpdateTimeout: 3000,
    heatMapRadius: 25,
    zoomForHeatMap: 14,
    searchZoom: 17,
    minOpacity: 0.2,
    maxOpacity: 1.0,
    animationTimeout: 1500,
    systems : {SMO:172},
    actionViewMap : '/visualizarMapa',
    actionDetailContract: '/detalhesContrato/',
    actionReportSimplified: '/relatorioSimplificado',
    actionReportDetailed: '/relatorioDetalhado',
    actionReportContractDetailed: '/relatorioContratoDetalhado/',
    actionReportEditable: '/relatorioEditavel',
    actionReportEditableContract: '/relatorioEditavelContrato/',
    actionPortal: '/portalDocumentos/'
}
export default ConstantSettings



// WEBPACK FOOTER //
// ./src/app/scripts/constants/constantSettings.js